import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import HeaderPortal from 'components/layout/HeaderPortal';
import GenericFilterTemplatesListBrowser from './GenericFilterTemplatesListBrowser';
import { withAreaGetter } from 'providers/AreasConsumers';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { ADMIN_GENERIC_FILTER_TEMPLATES_READ, ADMIN_GENERIC_FILTER_TEMPLATES_WRITE } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_GENERIC_FILTER_TEMPLATES_WRITE} withForbiddenPage={false}>
          <IconButton
            onClick={() => historyContext.push(`/genericFilterTemplates/new`)}
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Tooltips.GenericFilterTemplate.Add')}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_GENERIC_FILTER_TEMPLATES_READ}>
        <GenericFilterTemplatesListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
